/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export * from "./NoResultsIcon";
